import React, { useState } from 'react';

const Services = () => {
  const [flippedCards, setFlippedCards] = useState({});

  const services = [
    {
      title: "Website Design",
      description: "No matter if it's an existing website, or starting from scratch.",
      details: "From responsive design to e-commerce solutions, I create modern, user-friendly websites that drive results. Services include UI/UX design, custom development, WordPress integration, and ongoing maintenance.",
      icon: "fas fa-laptop-code"
    },
    {
      title: "SEO and Listing",
      description: "Take your site to the next level, ensure it's optimized for listing, and get the exposure you need!",
      details: "Boost your online visibility with comprehensive SEO strategies. Includes keyword optimization, local SEO, Google My Business management, content strategy, and performance tracking.",
      icon: "fas fa-search"
    },
    {
      title: "Mobile Apps",
      description: "Build a mobile app to take your business to the next level!",
      details: "Transform your business processes with custom PowerApps solutions. Create data-driven applications, automate workflows, and connect to your existing systems without complex coding.",
      icon: "fas fa-mobile-alt"
    }
  ];

  const toggleCard = (index) => {
    setFlippedCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <section className="services">
      <div className="container">
        <h3>Some of the ways I can help you or your business:</h3>
        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              className={`flip-card ${flippedCards[index] ? 'flipped' : ''}`}
              onClick={() => toggleCard(index)}
            >
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <div className="service-icon">
                    <i className={service.icon}></i>
                  </div>
                  <div className="service-content">
                    <h4><strong>{service.title}</strong></h4>
                    <p>{service.description}</p>
                  </div>
                  <div className="flip-hint">
                    <i className="fas fa-info-circle"></i>
                    <span>Click for more details</span>
                  </div>
                </div>
                <div className="flip-card-back">
                  <div className="service-details">
                    <h4><strong>{service.title}</strong></h4>
                    <p>{service.details}</p>
                  </div>
                  <div className="flip-hint">
                    <i className="fas fa-arrow-left"></i>
                    <span>Click to flip back</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="services-footer">… And More!</p>
      </div>
    </section>
  );
};

export default Services; 